import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { AggrementTermsOfServiceComponent } from '../shared/components/aggrement-terms-of-service/aggrement-terms-of-service.component';
import { ForgotPasswordComponent } from '../shared/components/forgot-password/forgot-password.component';
import { LoaderComponent } from '../shared/components/loader/loader.component';
import { MessageComponent } from '../shared/components/message/message.component';
import { SetPasswordComponent } from '../shared/components/set-password/set-password.component';
import { NoWhitespaceDirective } from '../shared/directives/no-whitespace.directive';
import { PreventSomeSpecialCharactersDirective } from '../shared/directives/prevent-some-special-characters.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    InputTextModule,
    ToastModule,
  ],
  declarations: [
    LoaderComponent,
    MessageComponent,
    ForgotPasswordComponent,
    SetPasswordComponent,
    AggrementTermsOfServiceComponent,
    NoWhitespaceDirective,
    PreventSomeSpecialCharactersDirective,
  ],
  exports: [
    TranslateModule,
    LoaderComponent,
    MessageComponent,
    ForgotPasswordComponent,
    SetPasswordComponent,
    AggrementTermsOfServiceComponent,
    NoWhitespaceDirective,
    PreventSomeSpecialCharactersDirective,
  ],
})
export class CoreSharedModule {}
